import React, { createContext, useContext, useState } from 'react';

const DatabaseContext = createContext();

export const DatabaseProvider = ({ children }) => {
  const [databaseState, setDatabaseState] = useState({
    isConnected: false,
    datasourceId: null,
    user_db_id: null,
    tables: [],
    tablesData: null,
  });

  const updateDatabaseState = (newState) => {
    setDatabaseState(prev => ({
      ...prev,
      ...newState,
    }));
  };

  const clearDatabaseState = () => {
    setDatabaseState({
      isConnected: false,
      datasourceId: null,
      user_db_id: null,
      tables: [],
      tablesData: null,
    });
  };

  return (
    <DatabaseContext.Provider
      value={{
        databaseState,
        updateDatabaseState,
        clearDatabaseState,
      }}
    >
      {children}
    </DatabaseContext.Provider>
  );
};

export const useDatabase = () => {
  const context = useContext(DatabaseContext);
  if (!context) {
    throw new Error('useDatabase must be used within a DatabaseProvider');
  }
  return context;
}; 